import { render, staticRenderFns } from "./notificationForm.vue?vue&type=template&id=2496415c&scoped=true"
import script from "./notificationForm.vue?vue&type=script&lang=js"
export * from "./notificationForm.vue?vue&type=script&lang=js"
import style0 from "./notificationForm.vue?vue&type=style&index=0&id=2496415c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2496415c",
  null
  
)

export default component.exports